module.exports = __webpack_public_path__ + "static/media/pallet.b4983d2f.jpg";